import Validation from '@/js/components/forms/validation';

class NewsletterSubscribe {
  constructor() {
    this.dom = {
      formSubscriber: document.getElementById('newsletter-form'),
    };

    this.components = {
      subscriberFormValidation: null,
    };

    this.mount();
  }

  mount() {
    if (this.dom.formSubscriber) {
      this.components.subscriberFormValidation = new Validation(this.dom.formSubscriber);
    }
  }
}

if (document.getElementById('newsletter-subscribe')) {
  // eslint-disable-next-line no-new
  new NewsletterSubscribe();
}
